import { Image, ImageProps } from '@chakra-ui/react'
import svg from 'assets/artwork/phone-apps.svg'
import { forwardRef } from 'react'

export const PhoneApps = forwardRef<HTMLImageElement, ImageProps>((props, ref) => {
    return <Image {...props} src={svg} alt="a phone with floating app icons" ref={ref} />
})
